/* MK: Kampagne-toggle i Boost-toolbaren (snippets/mk-sale-toggle.liquid).
   Filtrerer via Boosts API-param "pf_t_tag" (accepteres af Boosts API uden at filteret findes i
   filtertraeet; flere vaerdier = OR). Produkterne opdateres in-place med Boosts skeleton-loader, URL'en
   vedligeholdes af Boost (?pf_t_tag=...), og oevrige filtre bevares.
   Synlighed: ét JSONP-kald til Boosts filter-API (samme params som Boost selv, limit=1) giver
   total_product (kampagnevarer) og total_collection – knappen skjules ved 0 eller "alle". */
(function () {
  var PARAM = 'pf_t_tag';
  var toggles = [];
  var tags = [];
  var hideWhenAll = true;
  var counted = false;
  var visibleByCount = null; // null = ukendt endnu

  function getParamValues() {
    try {
      var v = window.Globals && window.Globals.queryParams ? window.Globals.queryParams[PARAM] : null;
      if (Array.isArray(v)) return v;
      if (typeof v === 'string' && v !== '') return [v];
    } catch (e) {}
    return [];
  }

  function isActive() {
    var cur = getParamValues().map(function (t) { return String(t).toLowerCase(); });
    return tags.some(function (t) { return cur.indexOf(t.toLowerCase()) > -1; });
  }

  function render() {
    var active = isActive();
    var show = active || visibleByCount === true;
    toggles.forEach(function (el) {
      var btn = el.querySelector('.mk-sale-toggle__btn');
      if (show) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      if (btn) btn.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }

  function onToggle() {
    var api = window.FilterApi;
    if (!api || typeof api.applyFilter !== 'function') return;
    var active = isActive();
    try {
      api.setParam(PARAM, active ? [] : tags.slice());
      api.setParam('page', 1);
      api.applyFilter('filter');
    } catch (e) { return; }
    toggles.forEach(function (el) {
      var btn = el.querySelector('.mk-sale-toggle__btn');
      if (btn) btn.setAttribute('aria-checked', active ? 'false' : 'true');
    });
  }

  // Taeller kampagnevarer i hele kollektionen via Boosts filter-API (JSONP, som Boost selv bruger).
  function countSaleProducts() {
    if (counted) return;
    var g = window.Globals, cfg = window.boostPFSConfig && (window.boostPFSConfig.api || window.boostPFSConfig.general);
    if (!g || !g.queryParams || !g.queryParams.shop || !cfg || !cfg.filterUrl) return;
    counted = true;
    var qp = g.queryParams;
    var parts = [];
    function add(k, v) { parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }
    Object.keys(qp).forEach(function (k) {
      if (k.indexOf('pf_') === 0 || k === 'callback' || k === 'limit' || k === 'page' || k === 'build_filter_tree' || k === 'event_type' || k === 't' || k === '_') return;
      var v = qp[k];
      if (v === null || v === undefined || v === '') return;
      if (Array.isArray(v)) v.forEach(function (x) { add(k + '[]', x); });
      else add(k, v);
    });
    add('limit', 1); add('page', 1); add('build_filter_tree', false); add('event_type', 'init');
    tags.forEach(function (t) { add(PARAM + '[]', t); });
    var cb = 'mkSaleToggleCb' + Math.floor(Math.random() * 1e9);
    var done = false;
    function finish(sale, total) {
      if (done) return; done = true;
      try { delete window[cb]; } catch (e) { window[cb] = undefined; }
      if (typeof sale !== 'number') { visibleByCount = true; render(); return; } // ved fejl: vis
      visibleByCount = sale > 0 && !(hideWhenAll && typeof total === 'number' && total > 0 && sale >= total);
      render();
    }
    window[cb] = function (data) {
      var total = data && data.total_collection;
      if (!(total > 0)) {
        // total_collection er 0 uden filtertrae; brug kollektionens antal fra Liquid (boostPFSConfig.general)
        try { total = parseInt(window.boostPFSConfig.general.collection_product_count, 10); } catch (e) { total = null; }
      }
      finish(data && data.total_product, total);
    };
    add('callback', cb);
    var s = document.createElement('script');
    s.async = true;
    s.src = cfg.filterUrl + '?' + parts.join('&');
    s.onerror = function () { finish(null); };
    document.head.appendChild(s);
    setTimeout(function () { finish(null); }, 8000);
  }

  function init() {
    toggles = Array.prototype.slice.call(document.querySelectorAll('[data-mk-sale-toggle]'));
    if (!toggles.length) return;
    tags = (toggles[0].getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    hideWhenAll = toggles[0].getAttribute('data-hide-when-all') !== 'false';
    if (!tags.length) return;
    toggles.forEach(function (el) {
      var btn = el.querySelector('.mk-sale-toggle__btn');
      if (btn) btn.addEventListener('click', onToggle);
    });
    try {
      if (window.FilterApi && typeof window.FilterApi.addAfterApplyFilter === 'function') {
        window.FilterApi.addAfterApplyFilter(function () { setTimeout(function () { render(); countSaleProducts(); }, 0); });
      }
    } catch (e) {}
    window.addEventListener('popstate', function () { setTimeout(render, 300); });
    // Boosts foerste svar kommer asynkront: poll indtil queryParams er udfyldt (max ~20 s)
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      render();
      countSaleProducts();
      if (counted || tries > 60) clearInterval(timer);
    }, 350);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
